import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import type { PreCashinInfo } from '../../../../../../../../../types/Cashier';

import {
  TXTCLI_You_can_make_N0_depositsX_incl_ELL,
  TXTCLI_You_can_make_Xb_classXXredXX1__ELL,
  TXTCLI_You_can_make_Xb_classXXredXX1__ELL_1,
  TXTCLI_You_can_make_one_more_deposit__ELL
} from './LastQualifyDeposit.messages.json';

interface Props {
  bonusMaxFormatted: JSX.Element;
  formattedDate: JSX.Element;
}

const LastQualifyDeposit: React.FC<Props> = ({ bonusMaxFormatted, formattedDate }) => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const {
    bonusPercent,
    maxNumberOfDeposits,
    lastAllowedDepositTime,
    maxNumberOfDepositsLeft,
    maxDaysForDepositLeft
  } = preCashinInfo as PreCashinInfo;

  if (maxDaysForDepositLeft) {
    const hasSameDepositsLeft = maxNumberOfDeposits === maxNumberOfDepositsLeft;
    return (
      <Translation
        tagName="p"
        {...(hasSameDepositsLeft
          ? TXTCLI_You_can_make_N0_depositsX_incl_ELL
          : TXTCLI_You_can_make_one_more_deposit__ELL)}
        values={{
          ...(hasSameDepositsLeft
            ? {
                0: maxNumberOfDepositsLeft,
                1: maxDaysForDepositLeft,
                2: formattedDate
              }
            : {
                0: formattedDate,
                1: bonusPercent,
                2: bonusMaxFormatted
              })
        }}
      />
    );
  }

  return (
    <Translation
      tagName="p"
      {...(!lastAllowedDepositTime
        ? TXTCLI_You_can_make_Xb_classXXredXX1__ELL
        : TXTCLI_You_can_make_Xb_classXXredXX1__ELL_1)}
      values={{
        0: bonusMaxFormatted,
        1: bonusPercent,
        2: formattedDate
      }}
    />
  );
};

export default LastQualifyDeposit;
